const OPENAI_PIXEL_ID = 'XsW1n2cm4iddiqF15C6tpA'
const OPENAI_PIXEL_SRC = 'https://bzrcdn.openai.com/sdk/oaiq.min.js'

type OaiqFn = ((...args: unknown[]) => void) & { q: unknown[][] }

declare global {
  interface Window {
    oaiq?: OaiqFn
    __oaiqLeadSent?: boolean
  }
}

/** Fires the OpenAI "lead_created" conversion once per page load. */
export function trackOpenAILead(): void {
  if (!window.oaiq || window.__oaiqLeadSent) return
  window.__oaiqLeadSent = true
  window.oaiq('measure', 'lead_created', {
    type: 'customer_action',
  })
}

/** Loads the OpenAI ads pixel once per page load. */
export function initOpenAIPixel(): void {
  if (typeof window === 'undefined' || window.oaiq) return

  const q = function (...args: unknown[]) {
    q.q.push(args)
  } as OaiqFn
  q.q = []
  window.oaiq = q

  const script = document.createElement('script')
  script.async = true
  script.src = OPENAI_PIXEL_SRC
  const first = document.getElementsByTagName('script')[0]
  if (first?.parentNode) {
    first.parentNode.insertBefore(script, first)
  } else {
    document.head.appendChild(script)
  }

  window.oaiq('init', {
    pixelId: OPENAI_PIXEL_ID,
    debug: true,
  })
}
